import { createAction, props } from '@ngrx/store';
import { EmployeeDoc } from '../_models/employeeDoc';

// Action types
export const loadEmployeeDocs = createAction('[EmployeeDoc] Load EmployeeDocs');
export const loadEmployeeDocsSuccess = createAction(
  '[EmployeeDoc] Load EmployeeDocs Success',
  props<{ employeeDocs: EmployeeDoc[] }>()
);
export const loadEmployeeDocsFailure = createAction(
  '[EmployeeDoc] Load EmployeeDocs Failure',
  props<{ error: any }>()
);

export const addEmployeeDoc = createAction(
  '[EmployeeDoc] Add EmployeeDoc',
  props<{ employeeDoc: EmployeeDoc }>()
);
export const addEmployeeDocSuccess = createAction(
  '[EmployeeDoc] Add EmployeeDoc Success',
  props<{ employeeDoc: EmployeeDoc }>()
);
export const addEmployeeDocFailure = createAction(
  '[EmployeeDoc] Add EmployeeDoc Failure',
  props<{ error: any }>()
);

export const updateEmployeeDoc = createAction(
  '[EmployeeDoc] Update EmployeeDoc',
  props<{ employeeDoc: EmployeeDoc }>()
);
export const updateEmployeeDocSuccess = createAction(
  '[EmployeeDoc] Update EmployeeDoc Success',
  props<{ employeeDoc: EmployeeDoc }>()
);
export const updateEmployeeDocFailure = createAction(
  '[EmployeeDoc] Update EmployeeDoc Failure',
  props<{ error: any }>()
);

export const deleteEmployeeDoc = createAction(
  '[EmployeeDoc] Delete EmployeeDoc',
  props<{ id: number }>()
);
export const deleteEmployeeDocSuccess = createAction(
  '[EmployeeDoc] Delete EmployeeDoc Success',
  props<{ id: number }>()
);
export const deleteEmployeeDocFailure = createAction(
  '[EmployeeDoc] Delete EmployeeDoc Failure',
  props<{ error: any }>()
);
